import { cookieNames, stashPlatformConstant } from 'stash/utils/native-bridge';
import { getCookie } from 'stash/utils/cookies';

/**
 * Checks for mobile viewport or device.
 * @returns {boolean}
 */
export const isMobileWeb = () => {
	const userAgent = navigator.userAgent.toLowerCase();
	const isMobileDevice =
		/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

	const isMobileWidth = window.matchMedia
		? window.matchMedia('(max-width: 768px)').matches
		: window.innerWidth <= 768;

	return isMobileDevice || isMobileWidth;
};

/**
 * Checks for native web view
 * @returns {boolean}
 */
export const isNativeWebview = () => {
	const stashPlatformVal = getCookie(cookieNames.NATIVE_PLATFORM);
	return (
		stashPlatformVal === stashPlatformConstant.ANDROID ||
		stashPlatformVal === stashPlatformConstant.IOS
	);
};
